import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class ReuniaoGTService {
    private urlModulo = `${environment.urlAPI}/reuniao-gt`;

    constructor(private http: HttpClient) { }

    /**
     * Recupera reunião GT por código
     */
    public getReuniaoGT(codigo: number): Promise<any> {
        const params = new HttpParams().set('codigo', codigo.toString());
        
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-byid`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.reuniaoGT);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Grava evento da reunião GT
     */
    public gravaEvento(eventoData: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlModulo}-salvarevento`, eventoData)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Grava itens do evento da reunião GT
     */
    public gravaItensEvento(itensData: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlModulo}-salvaritens`, itensData)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Registra decisão da reunião GT
     */
    public registraDecisao(decisaoData: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlModulo}-registradecisao`, decisaoData)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Grava comentário da reunião GT
     */
    public gravaComentario(codWorkflow: number, comentario: string, estacao: number): Promise<any> {
        const comentarioData = {
            codWorkflow: codWorkflow,
            comentario: comentario,
            estacao: estacao
        };

        return new Promise((resolve, reject) => {
            this.http.post(`${this.urlModulo}-salvarcomentario`, comentarioData)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }
}


// WEBPACK FOOTER //
// /app/src/app/services/reuniao-gt.service.ts